import { APIClient } from "api/api_helper";
import { VOLUNTEER_API } from "api/url_helper";
import {
    CurrentUser,
    GetUserData,
} from "common/service/CommonService";
import { LabTestsParams } from "../helper/studytest.types";
// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// Study Screening Lab Tests API SERVICE
// ------------------------------------------------------------------

export const labTestsApiService = {

    // SELECT ALL METHOD
    getSelectAllData: (params: LabTestsParams) => {
        const {
            studyid,
            volunteerid,
            searchText,
            pageNumber = 1,
            pageSize = 10,
        } = params;

        const payload = {
            status: "A",
            searchtext: searchText,
            pagenumber: pageNumber,
            pagesize: pageSize,
            studyid,
            volunteerid,
        };

        return api.create(VOLUNTEER_API.LAB_TESTS_API + "SelectAll", payload);
    },

// INSERT METHOD
    insertData: async (
        payload_data: LabTestsParams & {
            testedby: string;
            testdate: string;
            remarks?: string;
            reportname: string;
            attachment?: File | { file: File; type: string }[];
        }
    ) => {
        const user = GetUserData() as CurrentUser;
        const formData = new FormData();

        /* =====================================
           Normalize File Input (NO mutation)
        ====================================== */

        let attachments = payload_data.attachment;

        if (attachments instanceof File) {
            attachments = [{ file: attachments, type: "lab" }];
        }

        /* =====================================
           Append Normal Fields (Clean Mapping)
        ====================================== */

        Object.entries(payload_data).forEach(([key, value]) => {
            if (
                key === "attachment"
            ) {
                return;
            }

            // 🔁 Map fields properly
            if (key === "testdate") {
                formData.append("testdate", new Date(value as string).toISOString().split("T")[0]);
            }
            else if (typeof value === "object" && value !== null && "value" in value) {
                // select dropdown
                formData.append(key, String((value as any).value));
            }
            else {
                formData.append(key, String(value));
            }
        });

        /* =====================================
           Append Files (Binary)
        ====================================== */

        if (Array.isArray(attachments) && attachments.length > 0) {
            attachments.forEach((fileObj) => {
                if (fileObj?.file instanceof File) {
                    formData.append(`files`, fileObj.file);
                }
            });
        }

        /* =====================================
           System Fields (ONLY once)
        ====================================== */

        formData.append("createdby", String(user.userid));
        formData.append("studyid", String(localStorage.getItem("activestudyid")));
        formData.append("volunteerid", String(localStorage.getItem("activevolunteerid")));

        /* =====================================
           API Call
        ====================================== */

        return api.create(
            VOLUNTEER_API.LAB_TESTS_API + "Insert",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    },
// UPDATE METHOD
    updateData: async (
        payload_data: LabTestsParams & {
            testedby?: string;
            testdate?: string;
            remarks?: string;
            reportname?: string;
            attachment?: File | { file: File; type: string }[];
        }
    ) => {
        const user = GetUserData() as CurrentUser;

        const formData = new FormData();

        /* =====================================
           Normalize File Input (NO mutation)
        ====================================== */

        let attachments = payload_data.attachment;

        if (attachments instanceof File) {
            attachments = [{ file: attachments, type: "lab" }];
        }

        /* =====================================
           Append Normal Fields (Clean Mapping)
        ====================================== */

        Object.entries(payload_data).forEach(([key, value]) => {
            if (
                key === "attachment"
            ) {
                return;
            }

            if (key === "testdate") {
                formData.append(
                    "testdate",
                    new Date(value as string).toISOString().split("T")[0]
                );
            }
            else if (typeof value === "object" && value !== null && "value" in value) {
                formData.append(key, String((value as any).value));
            }
            else {
                formData.append(key, String(value));
            }
        });

        /* =====================================
           Append Files (ONLY files key)
        ====================================== */

        if (Array.isArray(attachments) && attachments.length > 0) {
            attachments.forEach((fileObj) => {
                if (fileObj?.file instanceof File) {
                    formData.append("files", fileObj.file);
                }
            });
        }

        /* =====================================
           System Fields
        ====================================== */

        formData.append("updatedby", String(user.userid));
        formData.append("studyid", String(localStorage.getItem("activestudyid")));
        formData.append("volunteerid", String(localStorage.getItem("activevolunteerid")));

        /* =====================================
           API Call
        ====================================== */

        return api.create(
            VOLUNTEER_API.LAB_TESTS_API + "Update",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    },
    // DELETE METHOD

    deleteData: (payload_data: {
        studyid?: number | null;
        volunteerid: number | null;
        studylabtestid?: number | null;
        updatereason: string;
    }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            studyid: payload_data.studyid,
            studylabtestid: payload_data.studylabtestid,
            volunteerid: payload_data.volunteerid,
            updatereason: payload_data.updatereason,
            updatedby: user.userid,
        };
        return api.create(VOLUNTEER_API.LAB_TESTS_API + "Delete", payload);
    },

    // VERIFY METHOD
    verifyLabTest: (payload: {
        verifypin: string;
        studylabtestid: number;
        studyid: number;
        volunteerid: number;
        verifystatus: string;
        verifiedby: number;
    }) => {
        return api.create(VOLUNTEER_API.LAB_TESTS_API + "Verify", payload);
    },
};
